export const LOAD_PORTFOLIO_INVESTMENTS_REQUEST =
  'LOAD_PORTFOLIO_INVESTMENTS_REQUEST'
export const LOAD_PORTFOLIO_INVESTMENTS_SUCCESS =
  'LOAD_PORTFOLIO_INVESTMENTS_SUCCESS'
export const LOAD_PORTFOLIO_INVESTMENTS_FAILURE =
  'LOAD_PORTFOLIO_INVESTMENTS_FAILURE'
